import React, { Component } from 'react';
import ReactTable from "react-table";
import PropTypes from 'prop-types';
import { Button} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import 'react-table/react-table.css';
import * as moment from 'moment';
import 'moment/locale/pt-br';

export default class TBLEstabelecimentos extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        this.columns = [
            {
                Header: 'Data de cadastro',
                accessor: 'createdAt',
                Cell: props => (<span>{moment(props.value).format("l")}</span>),
                className: "center"
            }, {
                Header: 'Nome Fantasia',
                accessor: 'nome_fantasia',
                className: "center"
            }, {
                Header: 'CNPJ',
                accessor: 'cnpj',
                className: "center"
            }, {
                Header: 'Endereço',
                accessor: 'endereco',
                Cell: props => props.value ?  (<span>{props.value.rua} {props.value.numero}, {props.value.bairro}</span>) : (''),
                width: 280,
            }, {
                Header: 'telefone',
                accessor: 'telefone',
                className: "center"
            }, {
                Header: 'Email',
                accessor: 'usuario',
                Cell: props => (<span>{props.value.email}</span>),
                className: "center",
            }, {
                Header: "Status",
                accessor: 'status',
                className: "center"
            }, {
                Header: "Ações",
                Cell: row => (
                    <div>
                        <Button size="sm" style={{ marginRight: 4 }}
                            onClick={() =>{ this.gerenciarAcoes("editar", row.row._original)}}><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></Button>
                        <Button size="sm" variant="danger"
                            onClick={() =>{ this.gerenciarAcoes("deletar", row.row._original)}}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></Button>
                    </div>
                ),
                className: "center"
            }];
    }

    gerenciarAcoes = (tipo, dados) => {
        if (tipo === "editar") {
            this.props.dataCallback(tipo, dados);
        } else if (tipo === "deletar") {
            this.props.dataCallback(tipo, dados);
        } else {
            return;
        }
    }

    render() {
        const { data, pages, loading, showPagination, limit, changePage } = this.props;
        return (
            <ReactTable
                data={data}
                columns={this.columns}
                resizable={false}
                manual
                pages={pages}
                onPageChange={page => changePage(page + 1)}
                showPagination={showPagination}
                defaultPageSize={limit}
                loading={loading}
                previousText='Anterior'
                nextText='Próximo'
                loadingText='Carregando estabelecimentos...'
                noDataText='Nenhum estabelecimento encontrado!'
                pageText='Página'
                ofText='de'
                rowsText='linhas'


            />
        );
    }
}

TBLEstabelecimentos.propTypes = {
    data: PropTypes.array,
    dataCallback: PropTypes.func,
    showPagination: PropTypes.bool,
    getEstabelecimentos: PropTypes.func,
    limit: PropTypes.number,
    pages: PropTypes.number,
    loading: PropTypes.bool,
    changePage: PropTypes.func

}
